module.exports = {"defaultId":"UA-122476993-1","products":"UA-122476993-2","ourlearnings":"UA-122476993-3","whoweare":"UA-122476993-4","selflearning":"UA-122476993-5","personalisedlearning":"UA-122476993-6","landing":"UA-122476993-7","homework":"UA-122476993-8"}


//////////////////
// WEBPACK FOOTER
// ./src/config/GA_Tracking_IDS.json
// module id = 1198
// module chunks = 0